import { User } from "../types/user";

export function getLDUserKey(env: string, user: User) {
    return env + "::" + user.id;
}

export function getLDWorkspaceKey(env: string, workspace: { id: string }) {
    return env + "::" + workspace.id;
}
